import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateTime from 'sharedWebpack/DateTime';
import Icon from '@wtag/rcl-icon';
import httpClient from 'agentHTTPClient';
import routes from 'agentRoutes';

import './styles.scss';

const Index = props => {
  const { journeyElementId, journeyElementType } = props;

  const [journeyElement, setJourneyElement] = useState({});

  const fetchJourneyElement = async () => {
    const { data } = await httpClient.get(
      routes.api.fetchJourneyElement({
        id: journeyElementId,
        type: journeyElementType,
      }),
    );

    setJourneyElement(data);
  };

  useEffect(() => {
    if (journeyElementId) {
      fetchJourneyElement();
    }
  }, [journeyElementId, journeyElementType]);

  const locationAndTime = (locationTimeObj, isBording) => (
    <div className="col-6 col-bleed col-grid align-center cruise-item__details-info">
      <div>
        <div className="col-grid col-bleed cruise-item__details-info-header">
          {isBording
            ? I18n.t('admin.components.orders.items_tab.placeholder.boarding')
            : I18n.t('admin.components.orders.items_tab.placeholder.off_boarding')}
        </div>
        <div className="col-grid col-bleed direction-row align-center cruise-item__details-info-time">
          <div className="cruise-item__details-info-time-icon">
            <Icon name="time" color="default" size="tiny" />
          </div>
          <div className="cruise-item__details-info-time-date">
            <DateTime format="shortWithTime" dateTime={locationTimeObj.localtimeInUserTz} />
          </div>
        </div>
        <div className="col-grid col-bleed direction-row align-center cruise-item__details-info-location">
          <div className="cruise-item__details-info-location-icon">
            <Icon name="mapMarker" size="tiny" color="danger" />
          </div>
          <div className="cruise-item__details-info-location-address">
            {locationTimeObj.location}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="col-12 cruise-item">
      <div className="cruise-item__header">
        <div className="cruise-item__header-name">{journeyElement.cruiseName}</div>
        {journeyElement.roomType && (
          <div className="cruise-item__header-room">
            {I18n.t('admin.components.orders.items_tab.tag.room_type', {
              room_type: journeyElement.roomType,
            })}
          </div>
        )}
      </div>
      <div className="col-12 col-grid direction-row justify-space-between cruise-item__details">
        {journeyElement.boarding && locationAndTime(journeyElement.boarding, true)}
        {journeyElement.offBoarding && locationAndTime(journeyElement.offBoarding, false)}
      </div>
      {journeyElement.food && (
        <div className="cruise-item-food">
          {I18n.t('admin.components.orders.items_tab.tag.food_name', {
            food_name: journeyElement.food,
          })}
        </div>
      )}
      <div className="col-grid col-bleed direction-row align-center justify-space-between cruise-item__footer">
        <div className="cruise-item__footer-facilities">
          {journeyElement.facilities &&
            I18n.t('admin.components.orders.items_tab.tag.facilities', {
              facilities: journeyElement.facilities,
            })}
        </div>
        <div className="cruise-item__footer-ship">{journeyElement.shipName}</div>
      </div>
    </div>
  );
};

Index.propTypes = {
  journeyElementId: PropTypes.number.isRequired,
  journeyElementType: PropTypes.string.isRequired,
};

export default Index;
